import IconButton from "@/components/buttons/IconButton";
import { Icon } from "@/components/icons/Icon";
import type { IconName } from "@/components/icons/icons";
import { ADMIN_MENU, BASE_URL, TMA_MENU } from "@/constants/constants";
import { cn } from "@/lib/styles.utils";
import { useUserStore } from "@/store/useUser";
import { Link, useLocation } from "react-router-dom";

const AsideMobile = ({
  setMobileOpen,
}: {
  setMobileOpen: (val: boolean) => void;
}) => {
  const { pathname } = useLocation();
  const { isSupervisor } = useUserStore();
  const MENU = isSupervisor ? ADMIN_MENU : TMA_MENU;
  return (
    <aside
      data-testid="aside-main-mobile"
      className="absolute top-0 left-0 h-full w-72 max-w-[85vw] bg-white shadow-lg"
    >
      <div className="h-12 px-4 flex items-center justify-between border-b">
        <div className="font-semibold">Menú</div>
        <IconButton
          className="p-2 rounded "
          icon="close"
          onClick={() => setMobileOpen(false)}
        />
      </div>

      <nav className="p-4 space-y-2">
        {MENU.map((it) => (
          <Link
            key={it.label}
            to={it.href}
            onClick={() => setMobileOpen(false)}
            className={cn(
              "flex gap-2 items-center rounded px-3 py-2 hover:bg-neutral-100",
              {
                "text-ib-red-main font-ib-bold":
                  it.href !== BASE_URL && pathname.includes(it.href),
              },
            )}
          >
            <Icon name={it.icon as IconName} className="" />
            <p>{it.label}</p>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default AsideMobile;
